// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.procedure-section {
  padding: 28px 16px;
  max-width: 1100px;
  margin: 0 auto 40px;
  font-family: 'Montserrat', sans-serif;
}

.procedure-title {
  text-align: center;
  font-size: 24px;
  margin: 0 0 6px;
  font-weight: 700;
}

.procedure-sub {
  text-align: center;
  color: #6b7280;
  margin-bottom: 36px;
}

.timeline {
  position: relative;
  padding: 8px 0 24px;
}

.timeline:before {
  content: '';
  position: absolute;
  left: 40px;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, rgba(15,118,110,0.06), rgba(15,118,110,0.04));
  border-radius: 2px;
}

.timeline-item {
  position: relative;
  width: 100%;
  padding: 12px 12px 20px 68px;
  box-sizing: border-box;
  margin-bottom: 18px;
}

.timeline-item .timeline-card {
  background: linear-gradient(135deg, #ffffff 0%, #f7fffc 100%);
  border: 1px solid rgba(15,118,110,0.06);
  box-shadow: 0 6px 18px rgba(15,118,110,0.03);
  border-radius: 12px;
  padding: 12px 14px 14px 14px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.card-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.timeline-item .timeline-content { max-width: calc(100% - 56px); }

.timeline-item h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.timeline-text {
  margin: 0;
  color: #334155;
  font-size: 14px;
  line-height: 1.5;
}

.timeline-marker {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #2563eb;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(15,118,110,0.12);
}
@media (max-width: 768px) {
  .passport-grid {
    flex-direction: column;
  }
}
.marker-number { font-size: 16px; }

@media (min-width: 900px) {
  /* desktop: center line and two-column alternating layout */
  .timeline:before { left: 50%; }
  .timeline-item { width: 50%; padding: 24px 40px; }
  .timeline-item.left { left: 0; text-align: right; padding-right: 40px; padding-left: 0; }
  .timeline-item.right { left: 50%; text-align: left; padding-left: 40px; padding-right: 0; }
  .timeline-item .timeline-card { justify-content: flex-start; }
  .timeline-item.left .timeline-card { margin-left: auto; }
  .timeline-item.right .timeline-card { margin-right: auto; }
  .timeline-marker { left: 50%; transform: translateX(-50%); top: 28px; }
  .timeline-item.left .timeline-card { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
  .timeline-item.right .timeline-card { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }
  /* Fix marker positioning: place marker near central line for left/right items */
  .timeline-marker { left: auto; transform: none; }
  .timeline-item.left .timeline-marker { right: -24px; left: auto; }
  .timeline-item.right .timeline-marker { left: -24px; right: auto; }
}

@media (max-width: 640px) {
  .procedure-section { padding: 20px 12px; }
  .procedure-title { font-size: 20px; }
  .timeline-item { padding-left: 64px; }
  .timeline-card { padding: 10px 12px; }
  .timeline-marker { width: 40px; height: 40px; left: 12px; top: 12px; }
  .procedure-sub {
  text-align: center;
  color: #6b7280;
  margin-bottom: 3px;
}
}
@media (max-width: 768px) {
.timeline-item .timeline-card {
gap: 0px;
 padding: 0;
}
}`, "",{"version":3,"sources":["webpack://./src/style/Procedure.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;EACvC,4CAA4C;EAC5C,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,mCAAmC,4BAA4B,EAAE;;AAEjE;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA,iBAAiB,eAAe,EAAE;;AAElC;EACE,2DAA2D;EAC3D,mBAAmB,SAAS,EAAE;EAC9B,iBAAiB,UAAU,EAAE,kBAAkB,EAAE;EACjD,sBAAsB,OAAO,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE;EACxF,uBAAuB,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;EAC1F,gCAAgC,2BAA2B,EAAE;EAC7D,qCAAqC,iBAAiB,EAAE;EACxD,sCAAsC,kBAAkB,EAAE;EAC1D,mBAAmB,SAAS,EAAE,2BAA2B,EAAE,SAAS,EAAE;EACtE,qCAAqC,4BAA4B,EAAE,+BAA+B,EAAE;EACpG,sCAAsC,6BAA6B,EAAE,gCAAgC,EAAE;EACvG,gFAAgF;EAChF,mBAAmB,UAAU,EAAE,eAAe,EAAE;EAChD,uCAAuC,YAAY,EAAE,UAAU,EAAE;EACjE,wCAAwC,WAAW,EAAE,WAAW,EAAE;AACpE;;AAEA;EACE,qBAAqB,kBAAkB,EAAE;EACzC,mBAAmB,eAAe,EAAE;EACpC,iBAAiB,kBAAkB,EAAE;EACrC,iBAAiB,kBAAkB,EAAE;EACrC,mBAAmB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,SAAS,EAAE;EACrE;EACA,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;AACA;AACA;AACA,QAAQ;CACP,UAAU;AACX;AACA","sourcesContent":[".procedure-section {\n  padding: 28px 16px;\n  max-width: 1100px;\n  margin: 0 auto 40px;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.procedure-title {\n  text-align: center;\n  font-size: 24px;\n  margin: 0 0 6px;\n  font-weight: 700;\n}\n\n.procedure-sub {\n  text-align: center;\n  color: #6b7280;\n  margin-bottom: 36px;\n}\n\n.timeline {\n  position: relative;\n  padding: 8px 0 24px;\n}\n\n.timeline:before {\n  content: '';\n  position: absolute;\n  left: 40px;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: linear-gradient(180deg, rgba(15,118,110,0.06), rgba(15,118,110,0.04));\n  border-radius: 2px;\n}\n\n.timeline-item {\n  position: relative;\n  width: 100%;\n  padding: 12px 12px 20px 68px;\n  box-sizing: border-box;\n  margin-bottom: 18px;\n}\n\n.timeline-item .timeline-card {\n  background: linear-gradient(135deg, #ffffff 0%, #f7fffc 100%);\n  border: 1px solid rgba(15,118,110,0.06);\n  box-shadow: 0 6px 18px rgba(15,118,110,0.03);\n  border-radius: 12px;\n  padding: 12px 14px 14px 14px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.card-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.timeline-item .timeline-content { max-width: calc(100% - 56px); }\n\n.timeline-item h3 {\n  margin: 0 0 8px;\n  font-size: 16px;\n}\n\n.timeline-text {\n  margin: 0;\n  color: #334155;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.timeline-marker {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #2563eb;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  box-shadow: 0 8px 18px rgba(15,118,110,0.12);\n}\n@media (max-width: 768px) {\n  .passport-grid {\n    flex-direction: column;\n  }\n}\n.marker-number { font-size: 16px; }\n\n@media (min-width: 900px) {\n  /* desktop: center line and two-column alternating layout */\n  .timeline:before { left: 50%; }\n  .timeline-item { width: 50%; padding: 24px 40px; }\n  .timeline-item.left { left: 0; text-align: right; padding-right: 40px; padding-left: 0; }\n  .timeline-item.right { left: 50%; text-align: left; padding-left: 40px; padding-right: 0; }\n  .timeline-item .timeline-card { justify-content: flex-start; }\n  .timeline-item.left .timeline-card { margin-left: auto; }\n  .timeline-item.right .timeline-card { margin-right: auto; }\n  .timeline-marker { left: 50%; transform: translateX(-50%); top: 28px; }\n  .timeline-item.left .timeline-card { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }\n  .timeline-item.right .timeline-card { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }\n  /* Fix marker positioning: place marker near central line for left/right items */\n  .timeline-marker { left: auto; transform: none; }\n  .timeline-item.left .timeline-marker { right: -24px; left: auto; }\n  .timeline-item.right .timeline-marker { left: -24px; right: auto; }\n}\n\n@media (max-width: 640px) {\n  .procedure-section { padding: 20px 12px; }\n  .procedure-title { font-size: 20px; }\n  .timeline-item { padding-left: 64px; }\n  .timeline-card { padding: 10px 12px; }\n  .timeline-marker { width: 40px; height: 40px; left: 12px; top: 12px; }\n  .procedure-sub {\n  text-align: center;\n  color: #6b7280;\n  margin-bottom: 3px;\n}\n}\n@media (max-width: 768px) {\n.timeline-item .timeline-card {\ngap: 0px;\n padding: 0;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
